// Hızlı Satış Ekran Ön Ayarları penceresi (görünüm + yerel yazıcı + adisyon) kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'sales.uiSettings';

export const uiSettingsGuide = (t: TFunction): GuideContent => ({
  layout: 'tabbed',
  title: t(`${G}.title`, 'Ekran ön ayarları nasıl yapılır?'),
  intro: t(`${G}.intro`, 'Bu pencere kasadaki satış ekranının görünümünü ve bu ekranın yazıcılarını ayarlar. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    tabs: t(`${G}.regions.tabs`, 'Görünüm / Yazdırma'),
    body: t(`${G}.regions.body`, 'Ayarlar'),
    footer: t(`${G}.regions.footer`, 'İptal / Kaydet'),
  },
  navItems: [
    t(`${G}.nav.appearance`, 'Görünüm'),
    t(`${G}.nav.printing`, 'Yazdırma'),
  ],
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Bu pencere ne işe yarar?'),
      text: t(`${G}.s1.text`, 'Satış sırasında ekranı kendi kullanımınıza göre düzenlersiniz: sepet genişliği, ürün kartı boyutları, kategori düğmeleri ve yazıcılar. Görünüm sekmesi ile Yazdırma sekmesi ayrı ayrı kaydedilir.'),
    },
    {
      region: 'tabs',
      title: t(`${G}.s2.title`, '2. Görünüm: sepet ve ürün kartları'),
      text: t(`${G}.s2.text`, '"Ürün Arama Bölümünü Göster" sepetin üstündeki barkod/ürün arama alanını açar veya gizler. "Sepet Bölümü Genişliği" sepeti daraltır ya da genişletir; sepet küçüldükçe ürün kartları alanı büyür. Ürün kartı, resim, yazı ve kategori sekmesi boyutlarını yüzde olarak ayarlayın.'),
      tips: [
        t(`${G}.s2.tip1`, '"Butonlar ve Numpad Konumu" ile ödeme düğmeleri ve tuş takımını sola veya sağa alın.'),
        t(`${G}.s2.tip2`, '"Resimleri Göster" ve "Fiyatları Göster" ürün kartında resmi ve fiyatı gösterir.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Kategori düğmeleri'),
      text: t(`${G}.s3.text`, 'Kategori yazı boyutunu ayarlayın ve düzeni seçin: "Yatay (Üstte)" ya da "Dikey (Yan)". Dikey düzende kategorilerin sol veya sağ tarafta duracağını seçebilirsiniz; çok kategori varsa kaydırarak ulaşılır.'),
      tips: [
        t(`${G}.s3.tip1`, '"Tümü" Kategorisini Göster kapalıysa ekran açılınca ilk kategori otomatik seçilir.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s4.title`, '4. Görünümü kaydedin'),
      text: t(`${G}.s4.text`, 'Görünüm sekmesinde "Kaydet" yalnız bir değişiklik yaptığınızda açılır. Görünüm ayarları bu bilgisayarda (tarayıcıda) saklanır; diğer kasaların görünümünü değiştirmez.'),
    },
    {
      region: 'tabs',
      title: t(`${G}.s5.title`, '5. Yazdırma: yazıcı seçimi'),
      text: t(`${G}.s5.text`, '"Tek Yazıcı Kullan" seçilirse tüm fişler varsayılan yazıcıdan çıkar. "Kategori Bazlı Yazıcı" seçilirse her kategori kendi yazıcısına gider; tüm ürünleri içeren adisyon "Adisyon Yazıcısı"ndan, kategorisi olmayan ürünler "Kategorisiz Ürün Yazıcısı"ndan çıkar.'),
      tips: [
        t(`${G}.s5.tip1`, 'Yazıcı listesi bilgisayardaki yerel servisten gelir; görünmüyorsa "Yerel Yazıcıları Yenile"ye basın. "Test" ile deneme sayfası yazdırın.'),
        t(`${G}.s5.tip2`, 'Ethernet/Wi-Fi termal yazıcıları "Ağ Yazıcıları" bölümünden IP adresiyle, sürücü kurmadan ekleyebilirsiniz.'),
        t(`${G}.s5.tip3`, '"Yazarkasa ile Birlikte Fiş Yazıcısı Kullan" açıksa her satışta önce yazarkasadan fiş kesilir, sonra fiş yazıcısından ayrıca fiş çıkar.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s6.title`, '6. Para çekmecesi ve adisyon'),
      text: t(`${G}.s6.text`, '"Para Çekmecesi Tetik Yazıcısı" nakit ödemede (veya karma ödemede nakit payı varsa) kasa çekmecesini açan yazıcıdır; "Çekmeceyi Test Et" ile deneyin. "Adisyon Yazdırma Ayarları" fişin başlığını, alt notunu ve biçimini ayarladığınız pencereyi açar.'),
      tips: [
        t(`${G}.s6.tip1`, 'Çekmece yazıcısı yalnız bu bilgisayara kaydedilir; her kasada ayrı seçilir.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s7.title`, '7. Yazdırma ayarlarını kaydedin'),
      text: t(`${G}.s7.text`, '"Yazdırma Ayarlarını Kaydet" yazıcı seçimlerini ve adisyon ayarlarını bu satış ekranına kaydeder; ekranı kullanan tüm kasalar aynı ayarı alır. Adisyon penceresinde "Kaydet" demek yetmez, buradan da kaydetmelisiniz. Sağ üstteki (i) bu rehberi yeniden açar.'),
    },
  ],
});
